import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";

function LegalLayout({ title, updated, children, testid }) {
  return (
    <div data-testid={testid} className="min-h-screen bg-[#16181D] text-[#F2F4F6]">
      <header className="border-b border-[#2D323E] bg-[#16181D]/90 px-4 py-4">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <Link to="/" aria-label="Volver al inicio">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="flex items-center gap-1.5 text-sm text-[#8A8F98] transition-colors hover:text-[#2EE6D6]"
          >
            <ArrowLeft className="h-4 w-4" /> Volver a la tienda
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">{title}</h1>
        <p className="mt-2 text-xs text-[#8A8F98]">Última actualización: {updated}</p>
        <div className="legal-body mt-8 space-y-6 text-sm leading-relaxed text-[#B7BDC7]">
          {children}
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="mb-2 font-heading text-lg font-semibold text-[#F2F4F6]">{title}</h2>
      {children}
    </section>
  );
}

const CONTACT = (
  <>
    Email:{" "}
    <a href="mailto:info@nubevaper.com" className="text-[#2EE6D6] hover:underline">
      info@nubevaper.com
    </a>{" "}
    · WhatsApp/Teléfono:{" "}
    <a href="tel:+34610935531" className="text-[#2EE6D6] hover:underline">
      +34 610 93 55 31
    </a>
  </>
);

export function AvisoLegal() {
  return (
    <LegalLayout title="Aviso Legal" updated="junio de 2026" testid="legal-notice-page">
      <Section title="1. Titular del sitio web">
        <p>
          El presente sitio web, accesible desde este dominio, es titularidad de NubeVape España
          (en adelante, «el Titular»), tienda independiente dedicada a la venta de productos de
          vapeo para mayores de edad. Datos de contacto: {CONTACT}.
        </p>
      </Section>
      <Section title="2. Objeto y condiciones de uso">
        <p>
          El acceso y uso de este sitio web atribuye la condición de usuario e implica la
          aceptación de las presentes condiciones. El sitio tiene por objeto la presentación y
          venta de vapers desechables y productos relacionados, exclusivamente a personas mayores
          de 18 años. El usuario declara ser mayor de edad y disponer de capacidad legal
          suficiente para realizar pedidos.
        </p>
      </Section>
      <Section title="3. Restricción por edad (+18)">
        <p>
          Conforme a la Ley 28/2005, de 26 de diciembre, y al Real Decreto 579/2017, está
          prohibida la venta de productos de vapeo a menores de 18 años. El acceso a la tienda
          requiere la confirmación expresa de mayoría de edad, y el Titular podrá denegar
          cualquier pedido si existen dudas razonables sobre la edad del comprador.
        </p>
      </Section>
      <Section title="4. Marcas y propiedad intelectual">
        <p>
          NubeVape España es una tienda independiente y no está afiliada, patrocinada ni
          respaldada por las marcas comercializadas (Razz Bar, Bang, Happ Bar, Rock Me, Vap Solo,
          Elf Bar, Lost Mary, entre otras). Todas las marcas, logotipos y nombres comerciales
          pertenecen a sus respectivos propietarios y se mencionan únicamente con fines
          identificativos.
        </p>
      </Section>
      <Section title="5. Pedidos, precios y disponibilidad">
        <p>
          Los pedidos se gestionan de forma personalizada a través de WhatsApp. Los precios
          mostrados incluyen los impuestos aplicables y pueden variar sin previo aviso; el precio
          definitivo es el confirmado en el momento de formalizar el pedido. La disponibilidad de
          stock es orientativa y se confirma siempre antes del pago.
        </p>
      </Section>
      <Section title="6. Responsabilidad">
        <p>
          Los productos de vapeo pueden contener nicotina, una sustancia adictiva. El uso de los
          productos es responsabilidad exclusiva del comprador. El Titular no se hace responsable
          del uso indebido de los productos ni de las compras realizadas facilitando datos falsos.
        </p>
      </Section>
      <Section title="7. Legislación aplicable">
        <p>
          Las presentes condiciones se rigen por la legislación española. Para cualquier
          controversia derivada del uso de este sitio web, las partes se someten a los juzgados y
          tribunales que resulten competentes conforme a derecho.
        </p>
      </Section>
    </LegalLayout>
  );
}

export function PoliticaPrivacidad() {
  return (
    <LegalLayout title="Política de Privacidad" updated="junio de 2026" testid="privacy-policy-page">
      <Section title="1. Responsable del tratamiento">
        <p>
          Responsable: NubeVape España. Contacto: {CONTACT}. Tratamos tus datos conforme al
          Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018 (LOPDGDD).
        </p>
      </Section>
      <Section title="2. Qué datos recogemos">
        <p>
          Esta web no dispone de registro de clientes ni pasarela de pago. Los pedidos se
          gestionan a través de WhatsApp, por lo que los datos que nos facilites en la conversación
          (nombre, dirección de envío, teléfono y método de pago) se utilizan únicamente para
          gestionar tu pedido. La verificación de edad y tus preferencias de cookies se guardan
          localmente en tu dispositivo y no se transmiten a nuestros servidores.
        </p>
      </Section>
      <Section title="3. Finalidad y base jurídica">
        <p>
          Los datos facilitados se tratan con la única finalidad de gestionar el pedido, el envío
          y la atención al cliente (base jurídica: ejecución del contrato de compraventa), así como
          para cumplir las obligaciones fiscales y contables derivadas de la venta (obligación
          legal).
        </p>
      </Section>
      <Section title="4. Conservación y destinatarios">
        <p>
          Los datos se conservan durante el tiempo necesario para gestionar el pedido y los plazos
          legalmente exigidos. No se ceden datos a terceros salvo obligación legal o a empresas de
          mensajería estrictamente para la entrega del pedido. WhatsApp (Meta Platforms) actúa como
          canal de comunicación bajo su propia política de privacidad.
        </p>
      </Section>
      <Section title="5. Tus derechos">
        <p>
          Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y
          portabilidad escribiéndonos a{" "}
          <a href="mailto:info@nubevaper.com" className="text-[#2EE6D6] hover:underline">
            info@nubevaper.com
          </a>
          . También tienes derecho a reclamar ante la Agencia Española de Protección de Datos
          (www.aepd.es).
        </p>
      </Section>
    </LegalLayout>
  );
}

export function PoliticaCookies() {
  return (
    <LegalLayout title="Política de Cookies" updated="junio de 2026" testid="cookies-policy-page">
      <Section title="1. ¿Qué son las cookies?">
        <p>
          Las cookies y tecnologías similares (como el almacenamiento local del navegador) son
          pequeños archivos que se guardan en tu dispositivo para recordar preferencias y mejorar
          tu experiencia de navegación.
        </p>
      </Section>
      <Section title="2. Cookies que utiliza esta web">
        <p>
          <strong className="text-[#F2F4F6]">Técnicas (necesarias):</strong> recuerdan tu
          verificación de edad (+18), tu preferencia sobre el banner de cookies y los productos de
          tu carrito. Sin ellas la tienda no puede funcionar correctamente.
        </p>
        <p>
          <strong className="text-[#F2F4F6]">De análisis:</strong> nos permiten conocer de forma
          anónima cómo se usa la web (páginas visitadas, tiempo de navegación) para mejorarla.
          Solo se utilizan si aceptas su uso en el banner de cookies.
        </p>
      </Section>
      <Section title="3. Gestión y desactivación">
        <p>
          Puedes aceptar o rechazar las cookies no esenciales desde el banner que aparece al
          entrar. Para cambiar tu decisión, borra los datos de navegación de este sitio desde la
          configuración de tu navegador y vuelve a entrar: el banner volverá a mostrarse. También
          puedes configurar tu navegador para bloquear o eliminar cookies en cualquier momento.
        </p>
      </Section>
      <Section title="4. Más información">
        <p>Para cualquier duda sobre el uso de cookies puedes contactarnos: {CONTACT}.</p>
      </Section>
    </LegalLayout>
  );
}
